<template>
  <manage-subscription></manage-subscription>
</template>

<script lang="ts" setup>
import ManageSubscription from '@/components/subscription/ManageSubscription.vue'
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router'
import { useOnboardingStore } from '@/store/onboarding/onboardingStore'
import { watch } from 'vue'

onBeforeRouteLeave((to, from, next) => {
  const onboarding = useOnboardingStore()
  if (onboarding.hasOnboarding && !onboarding.manualProccess) {
    onboarding.onboardingAlert = true
    onboarding.leave = false

    const unwatch = watch(
      () => onboarding.leave,
      confirmed => {
        if (confirmed) {
          onboarding.leave = false
          onboarding.onboardingAlert = false
          next()
        } else {
          onboarding.onboardingAlert = false
          next(false)
        }
        unwatch()
      },
    )
  } else {
    next()
  }
})
</script>

<style lang="scss"></style>
